import { useState } from 'react'
import { useEffect } from 'react'
import axios from 'axios'
import { useForm } from '@tanstack/react-form'
import classNames from 'classnames'
import { checkIsEmailValid, createFieldValidators } from '../../tools/validation'

const EditAdmin = ({ initialFormValue, action, onSave, onAdd }) => {
  const form = useForm({
    defaultValues: initialFormValue,

    onSubmit: ({ value }) => {
      if (action === 'edit') {
        onSave(value)
      }
      if (action === 'add') {
        onAdd(value)
      }
    },
  })

  useEffect(() => {
    form.reset(initialFormValue)
  }, [initialFormValue])

  const [account, setAccount] = useState({ copart: [], iaai: [] })

  useEffect(() => {
    axios(process.env.REACT_APP_BASE_URL + '/api/accounts').then(response => {
      let accounts = response.data.accounts
      setAccount({ copart: [...accounts.copart], iaai: [...accounts.iaai] })
    })
  }, [])

  return (
    <div className="edit-users-form-container">
      <form.Field name="username" validators={createFieldValidators(value => !value && 'Username is required')}>
        {field => (
          <div className="form-group">
            <label className="form-label">Username</label>
            <input
              type="text"
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter username"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="name">
        {field => (
          <div className="form-group">
            <label className="form-label">Name</label>
            <input
              type="text"
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter name"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="surname">
        {field => (
          <div className="form-group">
            <label className="form-label">Surname</label>
            <input
              type="text"
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter surname"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="password" validators={createFieldValidators(value => !value && 'Password is required')}>
        {field => (
          <div className="form-group">
            <label className="form-label">Password</label>
            <input
              type="password"
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter password"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="country">
        {field => (
          <div className="form-group">
            <label className="form-label">Country</label>
            <input
              type="text"
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter country"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="city">
        {field => (
          <div className="form-group">
            <label className="form-label">City</label>
            <input
              type="text"
              className="form-control"
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              placeholder="Enter city"
            />
          </div>
        )}
      </form.Field>

      <form.Field
        name="copartAccount"
        validators={createFieldValidators(value => !value && 'Copart account is required')}
      >
        {field => (
          <div className="form-group">
            <label className="form-label">Copart account</label>
            <select
              value={field.state.value}
              className={classNames('select', field.state.meta.errors.length > 0 && 'form-control-error')}
              onChange={event => field.handleChange(event.target.value)}
            >
              <option value="">Copart account</option>
              {account.copart.map(a => {
                return (
                  <option key={a.buyer} value={a.buyer}>
                    {a.buyer}
                  </option>
                )
              })}
            </select>
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="iaaiAccount">
        {field => (
          <div className="form-group">
            <label className="form-label">IAAI account</label>
            <select
              value={field.state.value}
              className={classNames('select', field.state.meta.errors.length > 0 && 'form-control-error')}
              onChange={event => field.handleChange(event.target.value)}
            >
              <option value="">IAAI account</option>
              {account.iaai.map(a => {
                return (
                  <option key={a.buyer} value={a.buyer}>
                    {a.buyer}
                  </option>
                )
              })}
            </select>
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field name="phone">
        {field => (
          <div className="form-group">
            <label className="form-label">Phone</label>
            <input
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              type="text"
              placeholder="Enter phone"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <form.Field
        name="email"
        validators={createFieldValidators(
          value => !value && 'Email is required',
          value => !checkIsEmailValid(value) && 'Email is not valid'
        )}
      >
        {field => (
          <div className="form-group">
            <label className="form-label">Email</label>
            <input
              className={classNames('form-control', field.state.meta.errors.length > 0 && 'form-control-error')}
              value={field.state.value}
              onChange={event => field.handleChange(event.target.value)}
              type="text"
              placeholder="Enter email"
            />
            {field.state.meta.errors.length > 0 && <span className="form-error">{field.state.meta.errors[0]}</span>}
          </div>
        )}
      </form.Field>

      <div className="checkboxes">
        <form.Field name="status">
          {field => (
            <div className="checkbox-box">
              <label className="checkbox-label" htmlFor="copart-status">
                Status
              </label>
              <input
                type="checkbox"
                id="copart-status"
                checked={field.state.value === 'active'}
                onChange={e => field.handleChange(e.target.checked ? 'active' : 'inactive')}
              />
            </div>
          )}
        </form.Field>
      </div>

      <div className="submit-button-container">
        {action === 'edit' && (
          <button className="save-user-button" onClick={form.handleSubmit}>
            Save
          </button>
        )}

        {action === 'add' && (
          <button className="save-user-button" onClick={form.handleSubmit}>
            Add new
          </button>
        )}
      </div>
    </div>
  )
}

export default EditAdmin
